<template>
  <TopHeader/>
  <TopNav/>

  <div class="pointer"></div>
  <DarkModeToggle/>
  <router-view />
</template>

<script>
import { DarkMode } from '@/legacy/initLegacy'
import DarkModeToggle from './components/DarkModeToggle.vue'
import TopHeader from '@/components/TopHeader.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'App',
  components: {
    DarkModeToggle,
    TopHeader,
    TopNav
  },
  data() {
  },
  mounted() {
    // Initialize dark mode
    DarkMode.init()
  },
}
</script>
